// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Users page — matches the app's dark theme (index.css tokens) and reuses
   the shared .candidate-table, .btn-*, .form-group and .status-badge idioms. */

.users-loading {
  color: var(--color-text-muted);
  padding: 20px 0;
}

.users-table-wrap {
  overflow-x: auto;
  margin-bottom: 40px;
}

.users-table {
  min-width: 640px;
}

.users-table th.col-actions,
.users-table td.user-actions {
  text-align: right;
  white-space: nowrap;
}

.user-name-cell {
  font-weight: 600;
  color: var(--color-text-light);
}

.user-email-cell {
  color: var(--color-text-muted);
}

.users-table tr.user-inactive td {
  color: var(--color-text-muted);
  opacity: 0.7;
}

.user-actions .btn-small {
  margin-right: 0;
  margin-left: 8px;
}

.you-badge {
  display: inline-block;
  margin-left: 8px;
  padding: 2px 9px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  border-radius: 12px;
  background-color: var(--wylie-cyan);
  color: var(--wylie-black);
  vertical-align: middle;
}

.admin-badge {
  display: inline-block;
  margin-left: 8px;
  padding: 2px 9px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  border-radius: 12px;
  background-color: var(--wylie-purple);
  color: var(--wylie-white);
  vertical-align: middle;
}

/* Status pills — build on the shared .status-badge base */
.status-badge.status-active {
  background-color: var(--wylie-green);
  color: var(--wylie-white);
}

.status-badge.status-inactive {
  background-color: #555555;
  color: var(--color-text-light);
}

/* Two side-by-side action cards, mirroring the .candidate-form card look */
.users-panels {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 25px;
  margin-bottom: 40px;
}

.users-panel {
  background-color: var(--color-bg-card);
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  border-top: 3px solid var(--wylie-purple);
}

.users-panel h2 {
  font-size: 1.35rem;
  color: var(--color-text-light);
  margin-bottom: 8px;
}

.panel-hint {
  color: var(--color-text-muted);
  font-size: 0.9rem;
  line-height: 1.5;
  margin-bottom: 22px;
}

.users-panel .btn-primary {
  width: 100%;
  margin-top: 6px;
}

/* Inline role selector in the users table */
.user-role-cell .role-select {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 0.85rem;
  max-width: 190px;
}

/* Success message — green counterpart to the shared .error-message */
.success-message {
  background-color: rgba(28, 95, 54, 0.25);
  color: #6fcf97;
  padding: 10px;
  border-radius: 4px;
  margin-bottom: 15px;
  border: 1px solid var(--wylie-green);
}
`, "",{"version":3,"sources":["webpack://./src/pages/Users.css"],"names":[],"mappings":"AAAA;+EAC+E;;AAE/E;EACE,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,mCAAmC;EACnC,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,qCAAqC;EACrC,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,0DAA0D;AAC1D;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA,2EAA2E;AAC3E;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA,4CAA4C;AAC5C;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,qEAAqE;AACrE;EACE,wCAAwC;EACxC,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,oCAAoC;AACtC","sourcesContent":["/* Users page — matches the app's dark theme (index.css tokens) and reuses\n   the shared .candidate-table, .btn-*, .form-group and .status-badge idioms. */\n\n.users-loading {\n  color: var(--color-text-muted);\n  padding: 20px 0;\n}\n\n.users-table-wrap {\n  overflow-x: auto;\n  margin-bottom: 40px;\n}\n\n.users-table {\n  min-width: 640px;\n}\n\n.users-table th.col-actions,\n.users-table td.user-actions {\n  text-align: right;\n  white-space: nowrap;\n}\n\n.user-name-cell {\n  font-weight: 600;\n  color: var(--color-text-light);\n}\n\n.user-email-cell {\n  color: var(--color-text-muted);\n}\n\n.users-table tr.user-inactive td {\n  color: var(--color-text-muted);\n  opacity: 0.7;\n}\n\n.user-actions .btn-small {\n  margin-right: 0;\n  margin-left: 8px;\n}\n\n.you-badge {\n  display: inline-block;\n  margin-left: 8px;\n  padding: 2px 9px;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n  border-radius: 12px;\n  background-color: var(--wylie-cyan);\n  color: var(--wylie-black);\n  vertical-align: middle;\n}\n\n.admin-badge {\n  display: inline-block;\n  margin-left: 8px;\n  padding: 2px 9px;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n  border-radius: 12px;\n  background-color: var(--wylie-purple);\n  color: var(--wylie-white);\n  vertical-align: middle;\n}\n\n/* Status pills — build on the shared .status-badge base */\n.status-badge.status-active {\n  background-color: var(--wylie-green);\n  color: var(--wylie-white);\n}\n\n.status-badge.status-inactive {\n  background-color: #555555;\n  color: var(--color-text-light);\n}\n\n/* Two side-by-side action cards, mirroring the .candidate-form card look */\n.users-panels {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));\n  gap: 25px;\n  margin-bottom: 40px;\n}\n\n.users-panel {\n  background-color: var(--color-bg-card);\n  padding: 30px;\n  border-radius: 10px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n  border-top: 3px solid var(--wylie-purple);\n}\n\n.users-panel h2 {\n  font-size: 1.35rem;\n  color: var(--color-text-light);\n  margin-bottom: 8px;\n}\n\n.panel-hint {\n  color: var(--color-text-muted);\n  font-size: 0.9rem;\n  line-height: 1.5;\n  margin-bottom: 22px;\n}\n\n.users-panel .btn-primary {\n  width: 100%;\n  margin-top: 6px;\n}\n\n/* Inline role selector in the users table */\n.user-role-cell .role-select {\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 0.85rem;\n  max-width: 190px;\n}\n\n/* Success message — green counterpart to the shared .error-message */\n.success-message {\n  background-color: rgba(28, 95, 54, 0.25);\n  color: #6fcf97;\n  padding: 10px;\n  border-radius: 4px;\n  margin-bottom: 15px;\n  border: 1px solid var(--wylie-green);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
